const Approvals = (function () {
  const body = nifty.body;
  function Approvals() {
    this.sendBtn = document.getElementById('formSend');
    this.form = document.getElementById('formValidacao');
    this.approve = $('#aprovar');
    this.reprove = $('#reprovar');
    this.approveBtn = document.getElementById('aprovarTodos');
    this.reproveBtn = document.getElementById('reprovarTodos');
    this.yes = $('input[value=S]');
    this.no = $('input[value=N]');
    this.modal = $('#modal-show');
    this.mobileExpenses = $('.mobile-grid__item:not(.is-total)');
    this.justificativaAprovar = $('#justificativaAprovar');
    this.justificativaReprovar = $('#justificativaReprovar');
    this.justificativa = $('#justificativa');
    this.inProgress = false;

    addEvents.call(this);
  }

  Approvals.prototype.approveAll = function() {
    this.no.prop('checked', false).closest('label').removeClass('active');
    this.yes.prop('checked', true).closest('label').addClass('active');
    this.mobileExpenses.removeClass('mobile-grid__item--reproved')
      .addClass('mobile-grid__item--approved');
    return this;
  };

  Approvals.prototype.reproveAll = function() {
    this.yes.prop('checked', false).closest('label').removeClass('active');
    this.no.prop('checked', true).closest('label').addClass('active');
    this.mobileExpenses.removeClass('mobile-grid__item--approved')
      .addClass('mobile-grid__item--reproved');
    return this;
  };


  const addEvents = function() {
    const _this = this;

    this.mobileExpenses.addClass('mobile-grid__item--approved');

    this.mobileExpenses.each(function(n, el) {
      const title = el.querySelector('.mobile-grid__title__text');

      el.addEventListener('click', function(e) {
        let target = $(e.target);

        if(target.is('.mobile-grid__title__text')) {
          return true;
        }

        target = target.closest('.mobile-grid__item');
        e.preventDefault();
        e.stopPropagation();

        body.overlay('show');
        $.get(target.prop('href'), function(html) {
          body.overlay('hide');
          _this.modal.find('.modal-body').html(html);
          _this.modal.modal('show');
        });
      });

      if (title) {
        title.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const target = $(e.target).closest('.mobile-grid__item');

          if (target.hasClass('mobile-grid__item--approved')) {
            target.removeClass('mobile-grid__item--approved')
              .addClass('mobile-grid__item--reproved');
          } else {
            target.removeClass('mobile-grid__item--reproved')
              .addClass('mobile-grid__item--approved');
          }

        });
      }
    });

    this.approveBtn.addEventListener('click', function() {
      _this.approveAll();
    });
    this.reproveBtn.addEventListener('click', function() {
      _this.reproveAll();
    });

    this.sendBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const $n = $('input[value=N]:checked');
      if ($n.length) {
        _this.reprove.find('#btn-reprovar').click(function () {
          if (!_this.inProgress) {
            _this.inProgress = true;
            body.overlay('show');
            _this.justificativa.val(_this.justificativaReprovar.val());
            _this.form.submit();
          }
        });
        _this.reprove.modal('show');
      } else {
        _this.approve.find('#btn-aprovar').click(function () {
          if (!_this.inProgress) {
            _this.inProgress = true;
            body.overlay('show');
            _this.justificativa.val(_this.justificativaAprovar.val());
            _this.form.submit();
          }
        });
        _this.approve.modal('show');
      }
    });
  }

  return Approvals;
}());

module.exports = Approvals;
